import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["prefix", "field", "errors"];
import "core-js/modules/es.promise.finally.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Q = Object.create;
var M = Object.defineProperty;
var Z = Object.getOwnPropertyDescriptor;
var q = Object.getOwnPropertyNames;
var G = Object.getPrototypeOf,
  W = Object.prototype.hasOwnProperty;
var X = function X(e, t) {
  return function () {
    return t || e((t = {
      exports: {}
    }).exports, t), t.exports;
  };
};
var ee = function ee(e, t, r, s) {
  if (t && typeof t == "object" || typeof t == "function") {
    var _iterator = _createForOfIteratorHelper(q(t)),
      _step;
    try {
      var _loop = function _loop() {
        var o = _step.value;
        !W.call(e, o) && o !== r && M(e, o, {
          get: function get() {
            return t[o];
          },
          enumerable: !(s = Z(t, o)) || s.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return e;
};
var A = function A(e, t, r) {
  return r = e != null ? Q(G(e)) : {}, ee(t || !e || !e.__esModule ? M(r, "default", {
    value: e,
    enumerable: !0
  }) : r, e);
};
var C = X(function (Le, k) {
  "use strict";

  var w = Object.defineProperty,
    te = Object.getOwnPropertyDescriptor,
    re = Object.getOwnPropertyNames,
    oe = Object.prototype.hasOwnProperty,
    se = function se(e, t) {
      for (var r in t) w(e, r, {
        get: t[r],
        enumerable: !0
      });
    },
    ne = function ne(e, t, r, s) {
      if (t && typeof t == "object" || typeof t == "function") {
        var _iterator2 = _createForOfIteratorHelper(re(t)),
          _step2;
        try {
          var _loop2 = function _loop2() {
            var o = _step2.value;
            !oe.call(e, o) && o !== r && w(e, o, {
              get: function get() {
                return t[o];
              },
              enumerable: !(s = te(t, o)) || s.enumerable
            });
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return e;
    },
    ie = function ie(e) {
      return ne(w({}, "__esModule", {
        value: !0
      }), e);
    },
    N = {};
  se(N, {
    Client: function Client() {
      return L;
    },
    createClient: function createClient() {
      return Y;
    },
    getDefaultClient: function getDefaultClient() {
      return be;
    },
    isFieldError: function isFieldError() {
      return le;
    }
  });
  k.exports = ie(N);
  var h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    ae = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
  function de(e) {
    e = String(e);
    for (var t, r, s, o, n = "", m = 0, l = e.length % 3; m < e.length;) {
      if ((r = e.charCodeAt(m++)) > 255 || (s = e.charCodeAt(m++)) > 255 || (o = e.charCodeAt(m++)) > 255) throw new TypeError("Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.");
      t = r << 16 | s << 8 | o, n += h.charAt(t >> 18 & 63) + h.charAt(t >> 12 & 63) + h.charAt(t >> 6 & 63) + h.charAt(t & 63);
    }
    return l ? n.slice(0, l - 3) + "===".substring(l) : n;
  }
  function pe(e) {
    if (e = String(e).replace(/[\t\n\f\r ]+/g, ""), !ae.test(e)) throw new TypeError("Failed to execute 'atob' on 'Window': The string to be decoded is not correctly encoded.");
    e += "==".slice(2 - (e.length & 3));
    for (var t, r = "", s, o, n = 0; n < e.length;) t = h.indexOf(e.charAt(n++)) << 18 | h.indexOf(e.charAt(n++)) << 12 | (s = h.indexOf(e.charAt(n++))) << 6 | (o = h.indexOf(e.charAt(n++))), r += s === 64 ? String.fromCharCode(t >> 16 & 255) : o === 64 ? String.fromCharCode(t >> 16 & 255, t >> 8 & 255) : String.fromCharCode(t >> 16 & 255, t >> 8 & 255, t & 255);
    return r;
  }
  var me = "2.8.1",
    U = function (e) {
      return e.REQUIRED_FIELD_MISSING = "REQUIRED_FIELD_MISSING", e.REQUIRED_FIELD_EMPTY = "REQUIRED_FIELD_EMPTY", e.TYPE_EMAIL = "TYPE_EMAIL", e.TYPE_NUMERIC = "TYPE_NUMERIC", e.TYPE_TEXT = "TYPE_TEXT", e;
    }(U || {});
  function le(e) {
    return e.code in U && e.field !== void 0;
  }
  function ce(e) {
    return e.errors !== void 0;
  }
  var ue = function ue(e) {
      return de(JSON.stringify(e));
    },
    fe = function fe(e) {
      var t = "@formspree/core@".concat(me);
      return e ? "".concat(e, " ").concat(t) : t;
    },
    ye = function ye() {
      return 1 * new Date();
    },
    b = function b(e, t, r) {
      e instanceof FormData ? e.append(t, r) : e = Object.assign(e, _defineProperty({}, t, r));
    },
    he = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var e, t, r, s, o, n, m, l, f, p, c;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e = _ref.stripePromise, t = _ref.response, r = _ref.responseData, s = _ref.payload, o = _ref.data, n = _ref.fetchImpl, m = _ref.request, l = _ref.url;
              _context.next = 3;
              return e.handleCardAction(r.stripe.paymentIntentClientSecret);
            case 3:
              f = _context.sent;
              if (!f.error) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", {
                response: t,
                body: {
                  errors: [{
                    code: "STRIPE_CLIENT_ERROR",
                    message: "Stripe SCA error",
                    field: "paymentMethod"
                  }]
                }
              });
            case 6:
              s.paymentMethod.id || b(o, "paymentMethod", s.paymentMethod.id), b(o, "paymentIntent", f.paymentIntent.id), b(o, "resubmitKey", r.resubmitKey);
              _context.next = 9;
              return n(l, _objectSpread(_objectSpread({}, m), {}, {
                body: JSON.stringify({
                  paymentIntent: f.paymentIntent.id,
                  resubmitKey: r.resubmitKey
                })
              }));
            case 9:
              p = _context.sent;
              _context.next = 12;
              return p.json();
            case 12:
              c = _context.sent;
              return _context.abrupt("return", {
                response: p,
                body: c
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function he(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
  function O(_ref3) {
    var e = _ref3.body,
      t = _ref3.response;
    return !ce(e) && (e == null ? void 0 : e.error) && (e = {
      errors: [{
        message: e.error
      }]
    }), {
      body: e,
      response: t
    };
  }
  var Ee = function Ee() {
      return navigator.webdriver || !!document.documentElement.getAttribute(pe("d2ViZHJpdmVy")) || !!window.callPhantom || !!window._phantom;
    },
    ge = /*#__PURE__*/function () {
      function ge() {
        _classCallCheck(this, ge);
        this.loadedAt = ye(), this.webdriver = Ee();
      }
      _createClass(ge, [{
        key: "teardown",
        value: function teardown() {}
      }, {
        key: "data",
        value: function data() {
          return {
            loadedAt: this.loadedAt,
            webdriver: this.webdriver
          };
        }
      }]);
      return ge;
    }(),
    L = /*#__PURE__*/function () {
      function L() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, L);
        this.project = e.project, this.stripePromise = e.stripePromise, typeof window < "u" && this.startBrowserSession();
      }
      _createClass(L, [{
        key: "startBrowserSession",
        value: function startBrowserSession() {
          this.session || (this.session = new ge());
        }
      }, {
        key: "teardown",
        value: function teardown() {
          this.session && this.session.teardown();
        }
      }, {
        key: "submitForm",
        value: function () {
          var _submitForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
            var r,
              s,
              o,
              n,
              m,
              l,
              f,
              p,
              c,
              y,
              _args2 = arguments;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  r = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                  s = r.endpoint || "https://formspree.io", o = r.fetchImpl || fetch, n = this.project ? "".concat(s, "/p/").concat(this.project, "/f/").concat(e) : "".concat(s, "/f/").concat(e), m = function m(p) {
                    return p instanceof FormData ? p : JSON.stringify(p);
                  }, l = {
                    Accept: "application/json",
                    "Formspree-Client": fe(r.clientName)
                  };
                  this.session && (l["Formspree-Session-Data"] = ue(this.session.data())), t instanceof FormData || (l["Content-Type"] = "application/json");
                  f = {
                    method: "POST",
                    mode: "cors",
                    body: m(t),
                    headers: l
                  };
                  if (!(this.stripePromise && r.createPaymentMethod)) {
                    _context2.next = 27;
                    break;
                  }
                  _context2.next = 7;
                  return r.createPaymentMethod();
                case 7:
                  p = _context2.sent;
                  if (!p.error) {
                    _context2.next = 10;
                    break;
                  }
                  return _context2.abrupt("return", {
                    response: null,
                    body: {
                      errors: [{
                        code: "STRIPE_CLIENT_ERROR",
                        message: "Error creating payment method",
                        field: "paymentMethod"
                      }]
                    }
                  });
                case 10:
                  b(t, "paymentMethod", p.paymentMethod.id);
                  _context2.next = 13;
                  return o(n, _objectSpread(_objectSpread({}, f), {}, {
                    body: t
                  }));
                case 13:
                  c = _context2.sent;
                  _context2.next = 16;
                  return c.json();
                case 16:
                  y = _context2.sent;
                  if (!(y && y.stripe && y.stripe.requiresAction && y.resubmitKey)) {
                    _context2.next = 23;
                    break;
                  }
                  _context2.next = 20;
                  return he({
                    stripePromise: this.stripePromise,
                    responseData: y,
                    response: c,
                    payload: p,
                    data: t,
                    fetchImpl: o,
                    request: f,
                    url: n
                  });
                case 20:
                  _context2.t0 = _context2.sent;
                  _context2.next = 24;
                  break;
                case 23:
                  _context2.t0 = O({
                    response: c,
                    body: y
                  });
                case 24:
                  return _context2.abrupt("return", _context2.t0);
                case 27:
                  return _context2.abrupt("return", o(n, f).then(function (p) {
                    return p.json().then(function (c) {
                      return O({
                        body: c,
                        response: p
                      });
                    });
                  }).catch());
                case 28:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, this);
          }));
          function submitForm(_x2, _x3) {
            return _submitForm.apply(this, arguments);
          }
          return submitForm;
        }()
      }]);
      return L;
    }(),
    Y = function Y(e) {
      return new L(e);
    },
    be = function be() {
      return v || (v = Y()), v;
    },
    v;
});
var F = A(C());
import u, { useEffect as D, useState as K, useContext as Fe, lazy as xe, Suspense as Pe } from "react";
import { loadStripe as Se } from "@stripe/stripe-js/pure.js";
var ve = xe(function () {
    return import("@stripe/react-stripe-js").then(function (e) {
      return {
        default: e.Elements
      };
    });
  }),
  j = u.createContext({
    client: void 0
  });
j.displayName = "Formspree";
var _,
  we = function we(e) {
    return _ || (_ = Se(e)), _;
  },
  V = function V(e, t) {
    var r = {};
    return e && (r.stripePromise = e), t && (r.project = t), (0, F.createClient)(r);
  },
  Ce = function Ce(e) {
    var _K = K(void 0),
      _K2 = _slicedToArray(_K, 2),
      t = _K2[0],
      r = _K2[1],
      _K3 = K(V(t, e.project)),
      _K4 = _slicedToArray(_K3, 2),
      s = _K4[0],
      o = _K4[1];
    return D(function () {
      return s.startBrowserSession(), function () {
        s.teardown();
      };
    }, []), D(function () {
      var n = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var m;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return we(e.stripePK);
              case 2:
                m = _context3.sent;
                r(m);
              case 4:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function n() {
          return _ref4.apply(this, arguments);
        };
      }();
      e.stripePK && n();
    }, [e.stripePK]), D(function () {
      t && o(V(t, e.project));
    }, [t]), u.createElement(j.Provider, {
      value: {
        client: s
      }
    }, e.stripePK ? u.createElement(u.Fragment, null, t && u.createElement(Pe, {
      fallback: u.createElement("p", null, "....")
    }, u.createElement(ve, {
      stripe: t
    }, u.createElement(u.Fragment, null, e.children)))) : u.createElement(u.Fragment, null, e.children));
  };
function T() {
  var e = Fe(j);
  return e.client ? e : {
    client: (0, F.getDefaultClient)()
  };
}
import { useState as x } from "react";
import { useElements as _e, CardElement as z, useStripe as je } from "@stripe/react-stripe-js";
var $ = "2.4.1";
var Te = function Te(e) {
    return e.preventDefault !== void 0;
  },
  Ie = function Ie(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _x4 = x(null),
      _x5 = _slicedToArray(_x4, 2),
      r = _x5[0],
      s = _x5[1],
      _x6 = x(!1),
      _x7 = _slicedToArray(_x6, 2),
      o = _x7[0],
      n = _x7[1],
      _x8 = x(!1),
      _x9 = _slicedToArray(_x8, 2),
      m = _x9[0],
      l = _x9[1],
      _x10 = x([]),
      _x11 = _slicedToArray(_x10, 2),
      f = _x11[0],
      p = _x11[1],
      c = T(),
      y = t.client || c,
      I,
      R;
    if (!y) throw new Error("You must provide a Formspree client");
    if (!e) throw new Error('You must provide a form key or hashid (e.g. useForm("myForm") or useForm("123xyz")');
    c.client && c.client.stripePromise && (I = je(), R = _e());
    var g = !!t.debug,
      E = t.data;
    return [{
      result: r,
      submitting: o,
      succeeded: m,
      errors: f
    }, /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(P) {
        var B, a, H, i, d, J;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              B = /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(i) {
                  var d;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        i.preventDefault();
                        d = i.target;
                        if (!(d.tagName != "FORM")) {
                          _context4.next = 4;
                          break;
                        }
                        throw new Error("submit was triggered for a non-form element");
                      case 4:
                        return _context4.abrupt("return", new FormData(d));
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function B(_x13) {
                  return _ref6.apply(this, arguments);
                };
              }();
              if (!Te(P)) {
                _context6.next = 7;
                break;
              }
              _context6.next = 4;
              return B(P);
            case 4:
              _context6.t0 = _context6.sent;
              _context6.next = 8;
              break;
            case 7:
              _context6.t0 = P;
            case 8:
              a = _context6.t0;
              H = function H(i, d) {
                a instanceof FormData ? a.append(i, d) : a = Object.assign(a, _defineProperty({}, i, d));
              };
              if (!(typeof E == "object")) {
                _context6.next = 28;
                break;
              }
              _context6.t1 = _regeneratorRuntime.keys(E);
            case 12:
              if ((_context6.t2 = _context6.t1()).done) {
                _context6.next = 28;
                break;
              }
              i = _context6.t2.value;
              d = void 0;
              if (!(typeof E[i] == "function")) {
                _context6.next = 24;
                break;
              }
              d = E[i].call(null);
              _context6.t3 = typeof (d == null ? void 0 : d.then) == "function";
              if (!_context6.t3) {
                _context6.next = 22;
                break;
              }
              _context6.next = 21;
              return d;
            case 21:
              d = _context6.sent;
            case 22:
              _context6.next = 25;
              break;
            case 24:
              d = E[i];
            case 25:
              d !== void 0 && H(i, d);
              _context6.next = 12;
              break;
            case 28:
              J = /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var i;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        i = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, a.address_line1 && {
                          line1: a.address_line1
                        }), a.address_line2 && {
                          line2: a.address_line2
                        }), a.address_city && {
                          city: a.address_city
                        }), a.address_country && {
                          country: a.address_country
                        }), a.address_state && {
                          state: a.address_state
                        }), a.address_postal_code && {
                          postal_code: a.address_postal_code
                        });
                        _context5.next = 3;
                        return I.createPaymentMethod({
                          type: "card",
                          card: R.getElement(z),
                          billing_details: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, a.name && {
                            name: a.name
                          }), a.email && {
                            email: a.email
                          }), a.phone && {
                            phone: a.phone
                          }), i && {
                            address: i
                          })
                        });
                      case 3:
                        return _context5.abrupt("return", _context5.sent);
                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function J() {
                  return _ref7.apply(this, arguments);
                };
              }();
              return _context6.abrupt("return", (n(!0), c.client.submitForm(e, a, {
                endpoint: t.endpoint,
                clientName: "@formspree/react@".concat($),
                createPaymentMethod: c.client && c.client.stripePromise ? J : void 0
              }).then(function (i) {
                var d = i.response.status,
                  S;
                return d === 200 ? (g && console.log("Form submitted", i), l(!0), s(i), p([])) : d >= 400 && (S = i.body, S.errors ? (p(S.errors), g && console.log("Error", i)) : (p([{
                  message: "Unexpected error"
                }]), g && console.log("Unexpected error", i)), l(!1)), i;
              }).catch(function (i) {
                throw g && console.log("Unexpected error", i), l(!1), i;
              }).finally(function () {
                n(!1);
              })));
            case 30:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x12) {
        return _ref5.apply(this, arguments);
      };
    }(), function () {
      n(!1), l(!1), p([]);
    }];
  };
import Re from "react";
var Me = function Me(e) {
  var t = e.prefix,
    r = e.field,
    s = e.errors,
    o = _objectWithoutProperties(e, _excluded),
    n = (s || []).find(function (m) {
      return m.field === r;
    });
  return n ? Re.createElement("div", _objectSpread({}, o), t, " ", n.message) : null;
};
var Ae = A(C());
var export_isFieldError = Ae.isFieldError;
export { z as CardElement, Ce as FormspreeProvider, Me as ValidationError, export_isFieldError as isFieldError, Ie as useForm, T as useFormspree };